import * as BABYLON from "babylonjs";
import { GridMaterial } from "babylonjs-materials";

export function createGround(scene: BABYLON.Scene) {





  const ground = BABYLON.CreateGround("ground", { width: 500, height: 500 }, scene)
  ground.material = new GridMaterial("groundMaterial", scene);
  const box = BABYLON.MeshBuilder.CreateBox("box", { height: 1, width: 500, depth: 500 }, scene);
  box.position.y = -0.5;
  box.isVisible = false;
  box.physicsImpostor = new BABYLON.PhysicsImpostor(box, BABYLON.PhysicsImpostor.BoxImpostor, {
    mass: 0,
    friction: 0.1,
  }, scene);


  // BABYLON.Mesh.CreateGroundFromHeightMap(
  //   "ground",
  //   "/textures/heightMap.png",
  //   400,
  //   400,
  //   100,
  //   0,
  //   10,
  //   scene,
  //   false,
  //   (ground) => {
  //     ground.material = new GridMaterial("groundMaterial", scene);
  //     ground.physicsImpostor = new BABYLON.PhysicsImpostor(ground, BABYLON.PhysicsImpostor.HeightmapImpostor, {
  //       mass: 0,
  //       friction: 0.2,
  //     }, scene);
  //   }
  // );









}